import {createSlice} from "@reduxjs/toolkit";

const initialState = {

    loading: false,
    error: null,
    userType: null,
    silent: false

}

const metaSlice = createSlice({
    name: 'meta',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload
        },
        setError: (state, action) => {
            state.error = action.payload
        },
        setUserType: (state, action) => {
            state.userType = action.payload
        },
        setSilent: (state, action) => {
            state.silent = action.payload
        },
    }
})

export const {setLoading, setError, setUserType, setSilent} = metaSlice.actions

export default metaSlice.reducer
